import { ApplicationArrayOutlineIcon } from './ApplicationArrayOutlineIcon';

/**
 * author: Michael Irigoyen
 * id D07A9442-941E-47BB-8B31-F2EB41DE069E
 * name application-array-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-array-outline.svg
 * tags
 * - Developer / Languages 
 */
export const IframeArrayOutlineIcon = ApplicationArrayOutlineIcon;
export default IframeArrayOutlineIcon